import clsx from "clsx";
import { Page } from "../components/page";
import { MultiPoster } from "../components/multi-poster";
import { InfoDialog } from "../components/welcome/info-dialog";
import translate from "../locales";
import { useContext, useEffect } from "react";
import { ClassroomContext } from "../components/classroom.context";
import { updateResponse } from "../collector";

export function PostReviewPage({ onPrevious }) {
  const { form } = useContext(ClassroomContext);

  useEffect(() => {
    updateResponse(form.values);
  }, []);

  return (
    <Page className="page--background post-review" logoType="colored">
      <title>{translate("post-review.page-title")}</title>
      <div className={clsx("page__content post-review__content--padded")}>
        <h1 className="post-review__mobile-title">
          {translate(["post-review", "dialog", "title"])}
        </h1>
        <div className={clsx("flex-box", "flex-box_column-mobile")}>
          <div className={clsx("card", "card--poster")}>
            <MultiPoster data={form.values} />
          </div>
          <InfoDialog translationScope={["post-review", "dialog"]}>
            <div className={clsx("flex-box")}>
              <button
                className={clsx("button", "button--outline", "sources")}
                onClick={onPrevious}
              >
                {translate("post-review.dialog.button-previous")}
              </button>
            </div>
          </InfoDialog>
        </div>
      </div>
    </Page>
  );
}
